import { Col, Row } from 'react-bootstrap';

import Button from '@/common/Button';
import { DATE_FE_FORMAT_FULL } from '@/constants';
import DateInput from '@/common/DateInput';
import Field from '@/common/Field';
import Form from '@/common/Form';
import HasPermission from '@/components/HasPermission';
import { License } from '@/models/gen/graphql';
import { ReactElement } from 'react';
import SelectLicenseType from '@/components/SelectLicenseType';
import SelectState from '@/components/SelectState';
import Tippy from '@tippyjs/react';

const LicensesForm = (): ReactElement => {
  const disabled = !HasPermission.check('allowUpdateUserProfile');
  return (
    <Form.Watch name="licenses">
      {([licenses = []]: [License[]], form) => (
        <>
          {licenses?.filter(Boolean).map((_license: License, index) => (
            <Row key={index}>
              <Col xs={4}>
                <Form.Field name={`licenses.${index}.number`} label="License Number">
                  <Form.Input name={`licenses.${index}.number`} validate disabled={disabled} />
                </Form.Field>
              </Col>
              <Col xs={2}>
                <Form.Field name={`licenses.${index}.expirationDate`} label="Exp Date">
                  <Form.Input
                    name={`licenses.${index}.expirationDate`}
                    as={DateInput}
                    format={DATE_FE_FORMAT_FULL}
                    validate
                    disabled={disabled}
                  />
                </Form.Field>
              </Col>
              <Col xs={2}>
                <Form.Field name={`licenses.${index}.stateCode`} label="State Code">
                  <Form.Input
                    name={`licenses.${index}.stateCode`}
                    as={SelectState}
                    placeholder="Select..."
                    searchable
                    validate
                    disabled={disabled}
                  />
                </Form.Field>
              </Col>
              <Col xs={4} className="d-flex gap-4">
                <Form.Field name={`licenses.${index}.licenseTypeId`} label="License Type" className="w-100">
                  <Form.Input
                    name={`licenses.${index}.licenseTypeId`}
                    as={SelectLicenseType}
                    placeholder="Select..."
                    searchable
                    validate
                    disabled={disabled}
                  />
                </Form.Field>
                <Field>
                  <Tippy content="Remove License">
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        form.setValue(
                          'licenses',
                          licenses.filter((license, i) => i !== index),
                          { shouldDirty: true }
                        );
                        form.trigger();
                      }}
                      disabled={disabled}
                    >
                      <i className="sv sv-trash" />
                    </Button>
                  </Tippy>
                </Field>
              </Col>
            </Row>
          ))}
          <Row>
            <Col xs={4}>
              <Field>
                <Form.Button
                  className="LicenseForm-Add"
                  variant="outline-success"
                  type="button"
                  onClick={() => {
                    form.setValue(
                      'licenses',
                      [
                        ...licenses,
                        {
                          number: '',
                          expirationDate: '',
                          stateCode: '',
                          licenseTypeId: '',
                        },
                      ],
                      { shouldDirty: true }
                    );
                    form.trigger();
                  }}
                  disabled={disabled}
                >
                  <span>
                    <i className="sv sv-plus-square" />
                  </span>
                  <span>Add License</span>
                </Form.Button>
              </Field>
            </Col>
          </Row>
        </>
      )}
    </Form.Watch>
  );
};

export default LicensesForm;
